import { SYSTEM_ERROR } from "config/CONSTANTS";
import axios from "axios";
import { GET_CANDIDATES_MODAL } from "../CONSTANTS";

/**
 * Function to fetch all the Candidates Detail.
 */
export const getCandidatesModal = (playerId) => {
  return new Promise((resolve, reject) => {
    try {
      axios
        .post(GET_CANDIDATES_MODAL(), {
          playerId: playerId,
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          console.log("getCandidatesModal > axios err=", err);
          reject(err.response.data);
          // reject("Error in getCandidatesModal axios!");
        });
    } catch (error) {
      console.error("in userServices > getCandidatesModal, Err===", error);
      reject(SYSTEM_ERROR);
    }
  });
};
